export const GET_PRODUCERS				       = 'GET_PRODUCERS'
export const GET_PRODUCERS_SUCCESS       = 'GET_PRODUCERS_SUCCESS'
export const GET_PRODUCERS_FAIL	       	 = 'GET_PRODUCERS_FAIL'
export const FIRST_FETCHING_MADE	       = 'FIRST_FETCHING_MADE'
export const LOAD_COMPLETED	             = 'LOAD_COMPLETED'